import AppointmentTable from './AppointmentTable';

const AppointmentList = () => {
  
    return (    
      <AppointmentTable key={0} /*appointments={appointmentList??[]}*//>
    );
}
export {AppointmentList}
